import mixpanel from 'mixpanel-browser';
import config from '../config';

function trackVariable(ctx) {
  // variables do need to be configured in GTM
  window?.dataLayer?.push(ctx);
}

function getUrlParams(pathname) {
  // get networkId, showId, episodeId from the URL
  // who is in the format /networks/:networkId/shows/:showId/episodes/:episodeId
  const [networkId, showId, episodeId] = ['networks', 'shows', 'episodes'].map((param) => {
    const index = pathname.split('/').indexOf(param);
    return index > -1 ? pathname.split('/')[index + 1] : null;
  });

  return { networkId, showId, episodeId };
}

function trackMixpanelEvent(action, properties) {
  if (!!config.env && config.env !== 'test') {
    mixpanel.track(action, properties);
  }
}

function trackEvent({ category, action, label, callback = () => {}, withIntercom = false }) {
  if (!!config.env && config.env !== 'test') {
    try {
      // *** GTM
      window?.dataLayer?.push({
        event: 'in-app-event',
        'event-category': category,
        'event-action': action,
        'event-label': label,
        eventCallback: callback,
      });

      //*** Mixpanel
      const { networkId, showId, episodeId } = getUrlParams(document.location.pathname);
      const properties = { category, label, networkId, showId, episodeId };
      // remove null properties
      Object.keys(properties).forEach((key) => properties[key] === null && delete properties[key]);
      mixpanel.track(action, properties);

      // *** Intercom
      if (withIntercom && window?.Intercom && typeof window.Intercom === 'function') {
        window.Intercom('trackEvent', action, {
          category,
          label,
        });
      }
    } catch (e) {
      // ignore tracking errors
    }
  }
}

export { trackEvent, trackMixpanelEvent, trackVariable, getUrlParams };
